import React, {Component} from 'react';
import {connect} from 'react-redux';
import Stacks from './components/stacks';
import Action from 'components/organisms/nhl-team-stacking/actions';
import Tooltip from 'components/atoms/tooltip';

class NHLTeamStacking extends Component {
    onClick(use) {
        this.props.dispatch(Action.useStacking(!use));
    }

    render() {
        const {sportConfig, stacking} = this.props;

        if (!sportConfig.isReady()) {
            return null;
        }

        return (
            <div className={`advanced-filter${stacking.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable NHL Team Stacking
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Enable NHL Team Stacking
                        <Tooltip subject="User will set max exposure limits for each team. Lineups are primarily driven by projections rather than forced team combinations." />
                    </button>
                </div>
                <Stacks />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, nhlTeamStacking} = state;

    return {
        sportConfig,
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(NHLTeamStacking);
